export const TRANSLATION_SCOPE = 'umsModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
export const TRANSLATION_CRUD_SCOPE = [TRANSLATION_SCOPE, 'crud'];
export const TRANSLATION_AUTH_TOKEN_SCOPE = [TRANSLATION_SCOPE, 'authToken'];
